import { authHeader } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

export async function obtenerPlanes() {
  const response = await fetch(`${API_URL}/api/v1/pagos/planes`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener los planes');
  }

  return response.json();
}

export async function iniciarPago(plan) {
  const response = await fetch(`${API_URL}/api/v1/pagos/iniciar`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({ plan }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al iniciar el pago');
  }

  return response.json();
}

export async function verificarPago(paymentId) {
  const response = await fetch(`${API_URL}/api/v1/pagos/verificar/${paymentId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al verificar el pago');
  }

  return response.json();
}

export function redirigirAPayPhone(paymentUrl) {
  if (!paymentUrl) {
    throw new Error('No se proporcionó una URL de redirección');
  }
  window.location.href = paymentUrl;
}

export async function manejarPago(plan) {
  try {
    const resultado = await iniciarPago(plan);
    
    // 🔥 CAMBIO: usar payment_url en lugar de redirect_url
    if (!resultado.payment_url) {
      throw new Error('No se recibió URL de redirección de PayPhone');
    }
    
    redirigirAPayPhone(resultado.payment_url);
    
    return {
      success: true,
      payment_id: resultado.payment_id,
      payment_url: resultado.payment_url,
      plan: resultado.plan,
      monto: resultado.monto,
      creditos: resultado.creditos
    };
  } catch (error) {
    console.error('Error en el proceso de pago:', error);
    throw error;
  }
}

// ============================================================
// 🔥 NUEVOS ENDPOINTS ADMINISTRATIVOS PARA PAGOS
// ============================================================

// [ADMIN] Listar todos los pagos con filtros
export async function listarPagosAdmin({
  usuarioId = null,
  email = null,
  estado = null,
  fechaDesde = null,
  fechaHasta = null,
  skip = 0,
  limit = 100
} = {}) {
  let url = `${API_URL}/api/v1/pagos/admin/pagos?skip=${skip}&limit=${limit}`;
  
  if (usuarioId) url += `&usuario_id=${usuarioId}`;
  if (email) url += `&email=${encodeURIComponent(email)}`;
  if (estado) url += `&estado=${estado}`;
  if (fechaDesde) url += `&fecha_desde=${fechaDesde}`;
  if (fechaHasta) url += `&fecha_hasta=${fechaHasta}`;

  const response = await fetch(url, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al listar los pagos');
  }

  return response.json();
}

// [ADMIN] Resumen de ingresos mensuales para el dashboard
export async function obtenerResumenPagosMensualAdmin() {
  const response = await fetch(`${API_URL}/api/v1/pagos/admin/pagos/resumen-mensual`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener el resumen de pagos');
  }

  return response.json();
}